export const GTV_STUDENT_SKU = 'cju-as-student1';

// This lookup maps RevenueCat/store product identifiers to Stripe SKUs. The student
// subscription is Stripe-web-only at launch, so `GTV_STUDENT_SKU` intentionally is not
// listed here until there is a real RevenueCat/store student product identifier to map.
export const skuByProductIdLookup: Record<string, string> & {
  defaultSku: string;
} = {
  'com.galateatv.unlimited.baseline.p1y': 'cju-as-8',
  'com.galateatv.unlimited.higher1.p1y': 'gtvu-as-2',
  'com.galateatv.unlimited.higher2.p1y': 'gtvu-as-3',
  'com.galateatv.unlimited.higher3.p1y': 'gtvu-as-4',

  'com.galateatv.unlimited.yearly.baseline': 'cju-as-8', // iOS WAP Yearly (normal)
  'com.galateatv.unlimited.yearly_higher_v1.p1y': 'cju-as-6',
  'com.galateatv.unlimited.yearly_higher_v2.p1y': 'cju-as-7',
  'com.galateatv.unlimited.yearly_higher_v1.p1w': 'cju-ws-wap', // iOS Weekly (Yearly Higher V1 offering)
  'com.galateatv.unlimited.yearly_higher_v2.p1w': 'cju-ws-wap', // iOS Weekly (Yearly Higher V2 offering)
  'com.galateatv.unlimited.weekly.baseline': 'cju-ws-wap', // iOS Weekly (normal package)
  'com.galateatv.unlimited.weekly.with_30_percent_first_week_discount': 'cju-ws-wap',
  'com.galateatv.unlimited.baseline:p1y': 'cju-as-8', // Android WAP (Yearly Normal) *
  'com.galateatv.unlimited.higher_v1:p1y': 'cju-as-6',
  'com.galateatv.unlimited.higher_v2:p1y': 'cju-as-7',

  'com.galateatv.unlimited.wap_higher.inidvidual.p1y': 'cju-as-waph', // iOS WAP Yearly Higher
  'com.galateatv.unlimited.wap_higher.inidividual_weekly.p1w': 'cju-ws-wap', // iOS Weekly (Higher package)
  'com.galateatv.unlimited.yearly.baseline:p1y': 'cju-as-waph', // Android WAP (Yearly Higher)

  'com.galateatv.unlimited.fp.individual.p1y': 'cju-as-fpi',
  'com.galateatv.unlimited.fp.individual:p1y': 'cju-as-fpi',
  'com.galateatv.unlimited.wap.inidvidual.p1y': 'cju-as-wapi',

  'com.galateatv.unlimited.weekly.baseline:p1w': 'cju-ws-wap', // Android Weekly (Both normal and higher packages) *

  'com.galateatv.unlimited.fp.individual_t2:p1y': 'cju-as-fpi-t2', // Android FP Individual Tier 2
  'com.galateatv.unlimited.fp.family_tier2:p1y': 'cju-as-fpf-t2', // Android FP Family Tier 2

  // Intro offer iOS products (Android uses normal products)
  'com.gtv.u.1w_1y_intro_20.baseline.p1w': 'cju-ws-wap',
  'com.gtv.u.1w_1y_intro_20.baseline.p1y': 'cju-as-8',
  'com.gtv.u.1w_1y_intro_30.baseline.p1w': 'cju-ws-wap',
  'com.gtv.u.1w_1y_intro_30.baseline.p1y': 'cju-as-8',

  // Weekly / Monthly / Yearly offering. Monthly (`cju-ms-1`) and yearly (`cju-as-8`) use their own
  // Stripe prices; weekly reuses the existing one. Google weekly/yearly use the existing baseline products above.
  'com.galateatv.unlimited.weekly.wma.p1w': 'cju-ws-wap', // iOS Weekly
  'com.galateatv.unlimited.monthly.wma.p1m': 'cju-ms-1', // iOS Monthly
  'com.galateatv.unlimited.annual.wma.p1y': 'cju-as-8', // iOS Yearly
  'com.galateatv.unlimited.monthly.wma:p1m': 'cju-ms-1', // Android Monthly

  // Candy crush point strategy
  'com.galateatv.coins_cc.small': 'cp-50-cc',
  'com.galateatv.coins_cc.medium': 'cp-250-cc',
  'com.galateatv.coins_cc.large': 'cp-500-cc',
  'com.galateatv.coins_cc.xlarge': 'cp-1250-cc',
  'com.galateatv.coins_cc.xxlarge': 'cp-2500-cc',
  'com.galateatv.coins_cc.xxxlarge': 'cp-5000-cc',

  'com.galateatv.coins.small': 'cp-500',
  'com.galateatv.coins.medium': 'cp-1000',
  'com.galateatv.coins.large': 'cp-2000',
  'com.galateatv.coins.xlarge': 'cp-3000',
  'com.galateatv.coins.xxlarge': 'cp-5000',
  'com.galateatv.coins.xxxlarge': 'cp-10000',
  'com.galateatv.coins_5000_at_half_price': 'cp-5000-cc',
  'com.galateatv.coins_10000_at_half_price': 'cp-10000',

  // Android August 2025 Pricing Test for Tier 2 Countries
  'com.galateatv.coins_tier2.small': 'cp-500-t2',
  'com.galateatv.coins_tier2.medium': 'cp-1000-t2',
  'com.galateatv.coins_tier2.large': 'cp-2000-t2',
  'com.galateatv.coins_tier2.xlarge': 'cp-3000-t2',
  'com.galateatv.coins_tier2.xxlarge': 'cp-5000-t2',
  'com.galateatv.coins_tier2.xxxlarge': 'cp-10000-t2',
  defaultSku: 'cju-as-8',
};
